import React, {useEffect} from 'react';
import If from '../../../../../vendors/components/If';
import {Card} from 'primereact/card';
import AnexoVisualizar from '../../../../components/anexo/AnexoVisualizar';
import EventoContribuicaoFormController from '../controller/evento-contribuicao-form.controller';

interface Props {
  controller: EventoContribuicaoFormController;
  style?: object;
  anexoOutrosMeios?: boolean
}

export default function AnexoContribuicao({controller, anexoOutrosMeios}: Props) {
  const lista = controller.lista;
  const user = controller.getUser();
  useEffect(() => {
    controller.obterAnexoContribuicao();
  }, []);

  return (
    <>

      <Card title="Documentação">
        <div className="like-card" style={{padding: '10px'}}>
          <div className="contribuicao-file">
            <If condition={!!lista && lista.length > 0}>
              {lista.map((m: any, index: any) =>
                <AnexoVisualizar key={`anexocontribuicao-${index}`}
                                 showDownload={!!user &&
                                   !!user.contribuinte &&
                                   user.contribuinte.codContribuinte == controller.contribuicao.codContribuinte ||
                                   m.stSigiloso == false
                                  }
                                 handleDownload={(e: any) => {
                                   controller.downloadContribuicao(m.cdSeqAnexoContribuicao);
                                 }}
                                 anexo={{noAnexo: m.noAnexo}}/>
              )}
            </If>
            <If condition={!lista || lista.length === 0}>
              <h4 className="text-center">Nenhum arquivo encontrado</h4>
            </If>
          </div>
        </div>
      </Card>

    </>
  );
};
